import LegalLayout, { LegalSection } from "@/components/site/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      testid="privacy-policy-page"
      eyebrow="Legal"
      title={<>Privacy<br />Policy</>}
      updated="July 1, 2026"
    >
      <LegalSection title="1. Overview" testid="privacy-section-overview">
        <p>
          UCUBE Technologies ("UCUBE", "we", "us", or "our") respects your privacy. This Privacy
          Policy explains what information we collect through our website, how we use it, and the
          choices you have. By using this website, you agree to the practices described below.
        </p>
      </LegalSection>

      <LegalSection title="2. Information We Collect" testid="privacy-section-collect">
        <p>We collect information in the following ways:</p>
        <ul>
          <li><strong>Information you provide:</strong> name, email address, company, and project details submitted through our contact form or email.</li>
          <li><strong>Automatically collected data:</strong> IP address, browser type, device information, and pages visited, gathered via standard web logs and analytics.</li>
          <li><strong>Cookies:</strong> small files used to remember preferences and understand site usage.</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. How We Use Your Information" testid="privacy-section-use">
        <ul>
          <li>To respond to enquiries and project briefs submitted through our contact form.</li>
          <li>To improve our website, services, and user experience.</li>
          <li>To send occasional updates about our services, if you have opted in.</li>
          <li>To comply with legal obligations.</li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Sharing of Information" testid="privacy-section-sharing">
        <p>
          We do not sell or rent your personal information. We may share information with trusted
          service providers who help us operate this website (such as hosting and analytics
          providers), and only to the extent necessary for them to perform their services, or
          where required by law.
        </p>
      </LegalSection>

      <LegalSection title="5. Data Retention" testid="privacy-section-retention">
        <p>
          We retain personal information only for as long as necessary to fulfil the purposes
          described in this policy, or as required by applicable law.
        </p>
      </LegalSection>

      <LegalSection title="6. Your Rights" testid="privacy-section-rights">
        <p>
          Depending on your location, you may have the right to access, correct, or request
          deletion of your personal information. To exercise these rights, contact us using the
          details below.
        </p>
      </LegalSection>

      <LegalSection title="7. Data Security" testid="privacy-section-security">
        <p>
          We use reasonable technical and organisational measures to protect your information.
          However, no method of transmission or storage is completely secure, and we cannot
          guarantee absolute security.
        </p>
      </LegalSection>

      <LegalSection title="8. Changes to This Policy" testid="privacy-section-changes">
        <p>
          We may update this Privacy Policy from time to time. Changes will be posted on this
          page with a revised "Last updated" date.
        </p>
      </LegalSection>

      <LegalSection title="9. Contact Us" testid="privacy-section-contact">
        <p>
          If you have questions about this Privacy Policy, contact us at{" "}
          <a href="mailto:contactus@ucubetechnologies.com">contactus@ucubetechnologies.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
